export var Language;
(function (Language) {
    Language[Language["NL"] = 0] = "NL";
    Language[Language["EN"] = 1] = "EN";
    Language[Language["DE"] = 2] = "DE"; // German
})(Language || (Language = {}));
